// extracted by mini-css-extract-plugin
export default {"payrollPage":"AllPayRoll_payrollPage__tVUlm","breadcrumb":"AllPayRoll_breadcrumb__GaiGp","newProject":"AllPayRoll_newProject__kW71l"};